(function () {
  if (window.__ucShipProgressBound) return;
  window.__ucShipProgressBound = true;

  var THRESHOLD = 10000;
  var unlocked = "You've unlocked free shipping on this order.";
  var lastTotal = null;

  window.__ucShipThreshold = THRESHOLD;
  window.__ucShipGetLastTotal = function () {
    return lastTotal;
  };

  function money(cents, currency) {
    var locale = (window.Shopify && Shopify.locale) || 'en-US';
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency || 'USD',
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function maybeCelebrate(total) {
    if (lastTotal !== null && lastTotal < THRESHOLD && total >= THRESHOLD) {
      window.__ucSuppressAddToCartToast = true;
      window.setTimeout(function () {
        window.__ucSuppressAddToCartToast = false;
      }, 3200);
      if (typeof window.__ucShipCelebrate === 'function') {
        window.__ucShipCelebrate();
      }
    }
    lastTotal = total;
  }

  function paint(cart) {
    if (!cart || typeof cart.total_price !== 'number') return;

    var empty = cart.item_count === 0 || !(cart.items && cart.items.length);
    var wrap = document.getElementById('UcShipProgress-wrap');
    if (empty) {
      if (wrap) wrap.innerHTML = '';
      document.querySelectorAll('[data-uc-ship-progress]').forEach(function (el) {
        el.remove();
      });
      lastTotal = 0;
      return;
    }

    var total = cart.total_price;
    var remaining = THRESHOLD - total;
    var pct = Math.min(100, Math.round((total / THRESHOLD) * 100));
    var met = remaining <= 0;
    var msg = met
      ? unlocked
      : "You're " + money(remaining, cart.currency) + ' away from free shipping ($100+).';

    maybeCelebrate(total);

    document.querySelectorAll('[data-uc-ship-progress], .uc-ship-progress').forEach(function (el) {
      el.classList.toggle('is-met', met);
      var p = el.querySelector('.uc-ship-progress__msg');
      var fill = el.querySelector('.uc-ship-progress__fill');
      var bar = el.querySelector('.uc-ship-progress__bar');
      if (p) p.textContent = msg;
      if (fill) fill.style.width = pct + '%';
      if (bar) bar.setAttribute('aria-valuenow', String(pct));
    });
  }

  function fetchCart() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(paint)
      .catch(function () {});
  }

  function onCartEvent(event) {
    var data = event && event.cartData;
    if (data && typeof data.total_price === 'number') {
      paint(data);
      return;
    }
    fetchCart();
  }

  function bind() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, onCartEvent);
    }
    document.addEventListener('cart:update', onCartEvent);
  }

  function boot() {
    bind();
    fetchCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
